module.exports = __webpack_public_path__ + "static/img/mokuaihua.fa7f5b2b.png";